import React from "react";

const ConvertRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.76794 2.60876C7.99372 2.40556 8.01202 2.0578 7.80882 1.83202C7.60562 1.60624 7.25786 1.58794 7.03208 1.79114L5.03208 3.59114C4.91618 3.69544 4.85001 3.84404 4.85001 3.99995C4.85001 4.15587 4.91618 4.30446 5.03208 4.40876L7.03208 6.20876C7.25786 6.41197 7.60562 6.39366 7.80882 6.16788C8.01202 5.9421 7.99372 5.59434 7.76794 5.39114L6.83334 4.55H9.00002C11.3472 4.55 13.25 6.45279 13.25 8.8V9C13.25 9.30376 13.4963 9.55 13.8 9.55C14.1038 9.55 14.35 9.30376 14.35 9V8.8C14.35 5.84528 11.9547 3.45 9.00002 3.45H6.83323L7.76794 2.60876ZM8.96795 9.79114C8.74217 9.58794 8.39441 9.60624 8.19121 9.83202C7.988 10.0578 8.00631 10.4056 8.23209 10.6088L9.1668 11.45H7.00002C4.65281 11.45 2.75002 9.54721 2.75002 7.2V7C2.75002 6.69625 2.50378 6.45 2.20002 6.45C1.89627 6.45 1.65002 6.69625 1.65002 7V7.2C1.65002 10.1547 4.0453 12.55 7.00002 12.55H9.16669L8.23209 13.3911C8.00631 13.5943 7.988 13.9421 8.19121 14.1679C8.39441 14.3937 8.74217 14.412 8.96795 14.2088L10.9679 12.4088C11.0838 12.3045 11.15 12.1559 11.15 12C11.15 11.844 11.0838 11.6954 10.9679 11.5911L8.96795 9.79114Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ConvertRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;